module.exports = __webpack_public_path__ + "images/line_friend_lp/campaign-hikakakusan_da1d573dc6a59c66b658a9de98e91e17.png";